export const ADMIN_LOGIN_LOADING = 'admin/loading'
export const ADMIN_LOGIN_FAIL = 'admin/fail'
export const ADMIN_LOGIN_SUCCESS = 'admin/success'
export const ADMIN_LOGOUT = 'admin/reset'
